'use client';

/**
 * Import and re-export `ColorScheme` so it can be used with the `use client` directive
 */
import {ColorScheme, useColorScheme, type ColorSchemeName} from '@udemy-v2/styles';

export {ColorScheme, useColorScheme, ColorSchemeName};
